export default __webpack_public_path__ + "static/media/bg-desktop.46e235ef.png";